//用于监听屏幕大小发生变化，初始化echarts
export default{
    data(){
        return{
            resizeTimer: null
        }
    },
    activated() {
        window.addEventListener('resize', this.onresize);
    },
    deactivated() {
		// 取消监听事件
		window.removeEventListener('resize', this.onresize);
	},
    methods: {
        onresize(e) {
			clearTimeout(this.resizeTimer);
			this.resizeTimer = setTimeout(() => {
                this.initEcharts();
			}, 200);
		},
    }
}


// WEBPACK FOOTER //
// ./src/minxins/resize.js